import Header from './Header';
import background from './img/softwarePartners.webp';
import MobileNavigation from './MobileNavigation';
import Footer from './Footer';

const DeveloperWooCommerceDownload = () => {
  return (
    <>
      <MobileNavigation />
      <section className="bg-[#212121] woo-commerce">
        <div
          className="w-full pb-28"
          style={{
            backgroundImage: `url(${background})`,
            backgroundSize: '200% 200%',
            backgroundPosition: 'bottom center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <Header />
          <div className="p-4 row md:p-8 how">
            <h3 className="text-white large">iQ Pro+ Woo Commerce Plugin - Downloads</h3>
          </div>
          <div className="flex p-16 row flex-col justify-center flex-start gap-6 self-stretch rounded-[28px] bg-white !mb-10">
            <table className="tg" style={{ undefined, tableLayout: 'fixed', width: '100%' }}>
              <colgroup>
                <col style={{ width: '25%' }} />
                <col style={{ width: '25%' }} />
                <col style={{ width: '25%' }} />
              </colgroup>
              <thead>
              <tr>
                <th>Name</th>
                <th>Size</th>
                <th>Last Modified</th>
              </tr></thead>
            <tbody>
              <tr>
                <td><b><a download={true} href="/IQProPlus.WooCommercePlugin-v1.0.4.zip" style={{ color: '#007bff', textDecoration: 'underline' }}>IQProPlus.WooCommercePlugin-v1.0.4.zip</a></b></td>
                <td><b>110 KB</b></td>
                <td><b>2026-10-15</b></td>
              </tr>
              <tr>
                <td><a download={true} href="/IQProPlus.WooCommercePlugin-v1.0.3.zip" style={{ color: '#007bff', textDecoration: 'underline' }}>IQProPlus.WooCommercePlugin-v1.0.3.zip</a></td>
                <td>765 KB</td>
                <td>2026-07-07</td>
              </tr>
              <tr>
                <td><a download={true} href="/IQProPlus.WooCommercePlugin-v1.0.2.zip" style={{ color: '#007bff', textDecoration: 'underline' }}>IQProPlus.WooCommercePlugin-v1.0.2.zip</a></td>
                <td>731 KB</td>
                <td>2026-05-28</td>
              </tr>
              <tr>
                <td><a download={true} href="/IQProPlus.WooCommercePlugin-v1.0.1.zip" style={{ color: '#007bff', textDecoration: 'underline' }}>IQProPlus.WooCommercePlugin-v1.0.1.zip</a></td>
                <td>765 KB</td>
                <td>2026-03-09</td>
              </tr>
              <tr>
                <td><a download={true} href="/IQProPlus.WooCommercePlugin-v1.0.0.zip" style={{ color: '#007bff', textDecoration: 'underline' }}>IQProPlus.WooCommercePlugin-v1.0.0.zip</a></td>
                <td>59 KB</td>
                <td>2026-02-02</td>
              </tr>
            </tbody>
            </table>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default DeveloperWooCommerceDownload;
